import { showConfirmModal } from "./showConfirmModal"

export const showBundlePlanModal = (props: {
  onConfirm: () => Promise<any> | any
}) => {
  showConfirmModal({
    title: t("ChangePlanReminder"),
    message: <div>{t("YouAreCurrentlyOnTheParcelpanelBun")} </div>,
    onConfirm: props.onConfirm,
    extraPrimaryAction: {
      content: t("ChangeBundlePlan"),
    },
  })
}
